module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-form', {
    staticClass: "demo-ruleForm login-container grijs",
    attrs: {
      "model": _vm.passwordForm,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "60px",
      "margin-top": "10px"
    }
  }, [_c('span', [_c('img', {
    staticStyle: {
      "float": "left",
      "height": "55px",
      "xwidth": "50px",
      "margin-top": "-5px"
    },
    attrs: {
      "src": require("../../static/img/logo-261-213.jpg")
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("EnergyWatch")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Change your Password")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "margin": "20px 0",
      "font-family": "Tahoma"
    }
  }, [_vm._v(" You have requested a password change, \n    so we send you this link. Please use the following field to enter a new value.\n    Each Password should be minimal 8 characters.")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "show-password": "",
      "auto-complete": "off",
      "placeholder": "Your new password"
    },
    model: {
      value: (_vm.passwordForm.password),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "password", $$v)
      },
      expression: "passwordForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "prop": "retype"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "show-password": "",
      "auto-complete": "off",
      "placeholder": "Retype password"
    },
    model: {
      value: (_vm.passwordForm.retype),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "retype", $$v)
      },
      expression: "passwordForm.retype"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [(_vm.passwordForm.password != _vm.passwordForm.retype) ? _c('span', {
    staticStyle: {
      "float": "left",
      "font-size": "12px",
      "color": "red"
    }
  }, [_vm._v("Passwords are not the same!")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.isPasswordInValid(),
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Change")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58775a8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ChangePassword.vue
// module id = 642
// module chunks = 1